import Dexie from 'dexie';
import * as  con from '../Constants'; // Adjust this path to your constants

class HistoricResultsDB extends Dexie {
    constructor() {
        super('HistoricResultsDB');
        this.version(1).stores({
            results: '++id'
        });
        this.results = this.table('results');
    }

    // Method 1: Add new result and prune if necessary
    async addResult(resultObj) {
        await this.results.add({ result: resultObj });

        const count = await this.results.count();
        if (count > con.MAX_ANNOTATION_RESULT_STACK_SIZE) {
            const toDelete = await this.results.orderBy('id').limit(count - con.MAX_ANNOTATION_RESULT_STACK_SIZE).toArray();
            await this.results.bulkDelete(toDelete.map(r => r.id));
        }
    }

    // Method 2: Get all results (newest first)
    async getAllResults() {
        return (await this.results.orderBy('id').reverse().toArray()).map(r => r.result);
    }
}

export const historicResultsDB = new HistoricResultsDB();